import { render, staticRenderFns } from "./EventNode.vue?vue&type=template&id=8fa1d66e&scoped=true&"
import script from "./EventNode.vue?vue&type=script&lang=js&"
export * from "./EventNode.vue?vue&type=script&lang=js&"
import style0 from "./EventNode.vue?vue&type=style&index=0&id=8fa1d66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa1d66e",
  null
  
)

component.options.__file = "www/vues/client/projectdisplay/event/EventNode.vue"
export default component.exports